import { DatabaseService } from './../database/database.service';
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable( {
  providedIn: 'root',
} )
export class BackgroundSyncService {
  envioActual = false;
  envioPresentismoActual = false; 
  examenesPorEnviarCollection: any[] = [];
  presentismoPorEnviarCollection: any[] = [];
  isConnected: boolean = false;
  private updatePorEnviar = new Subject<any>();
  updatePorEnviar$ = this.updatePorEnviar.asObservable();

  constructor( private databaseService: DatabaseService,
               private http: HttpClient ) {
  }

  updateTabPorEnviar( event ) {
    this.updatePorEnviar.next( event );
  }

  /**
   * @param {string} eventName puede recibir 2 valores posibles
   * @example 'close-examen' y 'save-examen'
   */
  public async registerEvent( eventName: string ): Promise<void> {
    // el evento es 'close-examen' o 'save-examen'
    navigator.serviceWorker.ready.then( ( swReg ) => {
      swReg.sync.register( eventName );
    } ).catch( console.log );
  }

  // from examenes.component
  public async checkPorEnviarTableChange( isConnected ) {
    this.isConnected = isConnected;
    this.examenesPorEnviarCollection = await this.databaseService.idb.table( 'examenesPorEnviar' ).toArray();
    this.presentismoPorEnviarCollection = await this.databaseService.idb.table( 'examenesPresentismoPorEnviar' ).toArray();
    if ( isConnected && sessionStorage.getItem( 'currentUser' ) ) {
      this.initSyncServer();
    }
  }

  initSyncServer() {
    this.initSyncServerPresentismo();
    this.initSyncServerPorEnviar();
  }

  initSyncServerPresentismo() {
    if ( this.presentismoPorEnviarCollection.length > 0 && this.isConnected && this.envioPresentismoActual == false) {
      this.envioPresentismoActual = true;
      this.sendDataServerPresente( this.presentismoPorEnviarCollection[ 0 ] );
    }
  }

  initSyncServerPorEnviar() {
    if ( this.examenesPorEnviarCollection.length > 0 && this.isConnected && this.envioActual == false) {
      this.envioActual = true;
      this.sendDataServer( this.examenesPorEnviarCollection[ 0 ] );
    }
  }

  async sendDataServer( item ) {
    await this.loadExam( item ).toPromise().then( response => {
      console.log( response );
      this.databaseService.idb.table( 'examenesPorEnviar' ).delete( item.id );
      this.examenesPorEnviarCollection.shift();
      this.updateTabPorEnviar( true );
      this.envioActual = false;
      setTimeout( () => {
        this.initSyncServerPorEnviar();
      }, 1000 );
    } ).catch( async ( error ) => {
      item.error = true;
      if ( error.error.errors ) {
        item.errorMessage = error.error.errors.map( e => {
          return e;
        } ).join( ' ' );
      } else {
        item.errorMessage = error.error.message;
      }
      item.errorOnTryToSendBySW.push( {
        timestamp: new Date().toString(),
        error:item.errorMessage
      } );
      await this.databaseService.updateExameneOnExamenesPorEnviarTable( 'PorEnviar', { ...item } );
      if ( item.errorOnTryToSendBySW.length < 3 && this.isConnected ) {
        setTimeout( () => {
          this.sendDataServer( item );
        }, 1000 );
      } else {
        this.examenesPorEnviarCollection.shift();
        this.updateTabPorEnviar( true );
        this.envioActual == false;
        setTimeout( () => {
          this.initSyncServerPorEnviar();
        }, 1000 );
      }
      console.log( error );
    } );
  }

  async sendDataServerPresente( item ) {
    await this.loadExam( item ).toPromise().then( response => {
      this.databaseService.idb.table( 'examenesPresentismoPorEnviar' ).delete( item.id );
      this.presentismoPorEnviarCollection.shift();
      this.envioPresentismoActual = false; 
      setTimeout( () => {
        this.initSyncServerPresentismo();
      }, 1000 );
    } ).catch( async ( error ) => {
      item.error = true;
      if ( error.error.errors ) {
        item.errorMessage = error.error.errors.map( e => {
          return e;
        } ).join( ' ' );
      } else {
        item.errorMessage = error.error.message;
      }
      item.errorOnTryToSendBySW.push( {
        timestamp: new Date().toString(),
        error:item.errorMessage
      } );
      if ( item.errorOnTryToSendBySW.length < 3 && this.isConnected ) {
        setTimeout( () => {
          this.sendDataServerPresente( item );
        }, 1000 );
      } else {
        this.presentismoPorEnviarCollection.shift();
        this.envioPresentismoActual = false; 
        this.updateTabPorEnviar( true );
        setTimeout( () => {
          this.initSyncServerPresentismo();
        }, 1000 );
      }
      console.log( error );
    } );
  }

  loadExam( data: any ) {
    if ( data.fueCerrado ) {
      return this.http.put<any>( data.onOnlineSendTo, data.examenDataToSend );
    } else {
      return this.http.post<any>( data.onOnlineSendTo, data.examenDataToSend );
    }
  }
}
